module.exports = __webpack_public_path__ + "static/media/time_overdue.d98b032c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/time_overdue.svg
// module id = 1969
// module chunks = 33